// @flow
import { ICONS } from '../constants';

const getIcon = (name: string) => {
  let icon;

  switch (name) {
    case 'twitter':
      icon = ICONS.TWITTER;
      break;
    case 'github':
      icon = ICONS.GITHUB;
      break;
    case 'vkontakte':
      icon = ICONS.VKONTAKTE;
      break;
    case 'telegram':
      icon = ICONS.TELEGRAM;
      break;
    case 'email':
      icon = ICONS.EMAIL;
      break;
    case 'rss':
      icon = ICONS.RSS;
      break;
    case 'instagram':
      icon = ICONS.INSTAGRAM;
      break;
    case 'tiktok':
      icon = ICONS.TIKTOK;
      break;
    case 'bluesky':
      icon = ICONS.BLUESKY;
      break;
    case 'substack':
      icon = ICONS.SUBSTACK;
      break;
    case 'google-scholar':
      icon = ICONS.GOOGLESCHOLAR;
      break;
    case 'x-twitter':
      icon = ICONS.XTWITTER;
      break;
    default:
      icon = {};
      break;
  }

  return icon;
};

export default getIcon;
